import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import moment from 'moment';
import IconInfo from '@spothero/icons/info';
import TextButton from '@spothero/ui/text-button';
import {DESTINATION_DATA} from 'destination/destination-prop-types';
import CitySchema from 'city/CitySchema';
import DestinationSchema from 'destination/DestinationSchema';
import EventSchema from 'event/EventSchema';

const SearchControlsHeading = ({
    isMonthly,
    city,
    destination,
    event,
    searchType,
    title,
    displayTitle,
    description,
    onShowInfoClick,
}) => {
    let eventUrl = null;
    let eventMetaDescription = null;
    let eventStarts = null;
    let eventEnds = null;

    if (searchType === 'event') {
        /* eslint-disable camelcase */
        const {starts, ends, search_url, meta_description} = event;
        const {timezone} = city;
        const startsInTimezone = moment.tz(starts, timezone);
        const endsInTimezone = moment.tz(ends, timezone);

        eventUrl = search_url;
        eventMetaDescription = meta_description;
        eventStarts = startsInTimezone.toISOString();
        eventEnds = endsInTimezone.toISOString();
        /* eslint-enable camelcase */
    }

    return (
        <div
            className="SearchControlsHeading"
            itemScope
            itemType="http://schema.org/Place"
        >
            <h1>
                <span>{displayTitle}</span>
                <meta itemProp="name" content={title} />
                {description && (
                    <TextButton
                        className="SearchControlsHeading-info-link"
                        onClick={onShowInfoClick}
                    >
                        <IconInfo />
                    </TextButton>
                )}
            </h1>
            {searchType === 'city' && <CitySchema city={city} />}
            {(searchType === 'destination' || searchType === 'venue') && (
                <DestinationSchema destination={destination} city={city} />
            )}
            {searchType === 'event' && (
                <EventSchema
                    url={eventUrl}
                    metaName={title}
                    metaDescription={eventMetaDescription}
                    starts={eventStarts}
                    ends={eventEnds}
                    destination={destination}
                    city={city}
                />
            )}
        </div>
    );
};

SearchControlsHeading.propTypes = {
    isMonthly: PropTypes.bool.isRequired,
    city: PropTypes.object.isRequired,
    destination: PropTypes.shape(DESTINATION_DATA),
    event: PropTypes.object,
    searchType: PropTypes.string,
    title: PropTypes.string,
    displayTitle: PropTypes.string,
    description: PropTypes.string,
    onShowInfoClick: PropTypes.func.isRequired,
};

const mapStateToProps = ({
    city: {data: city},
    destination: {data: destination},
    event: {data: event},
    search: {
        data: {searchType},
    },
    searchRequest: {monthly: isMonthly},
}) => {
    let newTitle = null;
    let displayTitle = null;
    let newDescription = null;

    if (searchType === 'city') {
        const {display_name: title, description} = city;

        newTitle = unescape(title);
        displayTitle = `${newTitle} ${isMonthly ? 'Monthly ' : ''}Parking`;
        newDescription = description;
    } else if (searchType === 'destination' || searchType === 'venue') {
        const {title, description} = destination;

        newTitle = unescape(title);
        displayTitle = `${newTitle} ${isMonthly ? 'Monthly ' : ''}Parking`;
        newDescription = description;
    } else if (searchType === 'event') {
        const {title, description} = event;

        newTitle = unescape(title);
        displayTitle = `${newTitle} Parking`;
        newDescription = description || destination.description;
    }

    return {
        isMonthly,
        city,
        destination,
        event,
        searchType,
        title: newTitle,
        displayTitle,
        description: newDescription,
    };
};

export default connect(mapStateToProps)(SearchControlsHeading);
